// frontend/src/components/Samples/NumberSeries.jsx

import React from 'react';
import { numberSeriesAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const NumberSeries = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('number_series.code', 'Series Code'),
      field: 'series_code',
      className: 'code-column'
    },
    {
      header: t('number_series.prefix', 'Prefix'),
      field: 'series_prefix'
    },
    {
      header: t('number_series.last_number', 'Last Number'),
      field: 'last_number',
      className: 'text-right'
    },
    {
      header: t('number_series.padding', 'Padding'),
      field: 'padding',
      className: 'text-center'
    },
    {
      header: t('number_series.description', 'Description'),
      field: 'description'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: false
    }
  ];

  const formFields = [
    {
      name: 'seriesCode',
      label: 'number_series.code',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'seriesPrefix',
      label: 'number_series.prefix',
      type: 'text',
      maxLength: 10
    },
    {
      name: 'lastNumber',
      label: 'number_series.last_number',
      type: 'number',
      required: true,
      min: 0,
      defaultValue: 0
    },
    {
      name: 'padding',
      label: 'number_series.padding',
      type: 'number',
      required: true,
      min: 1,
      max: 10,
      defaultValue: 6
    },
    {
      name: 'description',
      label: 'number_series.description',
      type: 'text',
      maxLength: 50
    },
    {
      name: 'notes',
      label: 'notes',
      type: 'textarea',
      rows: 3
    }
  ];

  return (
    <MasterDataManager
      title="number_series.title"
      subtitle="number_series.subtitle"
      createButtonLabel="number_series.create"
      api={numberSeriesAPI}
      columns={columns}
      formFields={formFields}
      idField="series_id"
      displayField="series_code"
    />
  );
};

export default NumberSeries;